import { cy, enGB, nl } from 'date-fns/locale'
import { useTranslation } from 'react-i18next'
import type { SupportedLanguage } from '../i18n'

export function useDateLocale() {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language as SupportedLanguage

  switch (currentLanguage) {
    case 'nl':
      return nl
    case 'cy':
      return cy
    case 'en':
    default:
      return enGB
  }
}
